enum ConnectionState {
  /**
   * Connection has not started yet or was explicitly closed by
   * the user
   */
  Off        = 'off',
  /**
   * We're actively connecting (either calling a backend API or
   * connecting to the signaling server)
   */
  Connecting = 'connecting',
  /**
   * Connection attempt has failed and we're waiting for next
   * connection attempt
   */
  Failed     = 'failed',
  /**
   * Connection to signagling server has been established and room
   * was joined
   */
  On         = 'on',
}

export default ConnectionState;
